/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1PecegepayBilletCancelSerial200,
  PatchApiV1PecegepayBilletCancelSerial401,
  PatchApiV1PecegepayBilletCancelSerial500,
  PatchApiV1PecegepayBilletCancelSerialMutationResponse,
  PatchApiV1PecegepayBilletCancelSerialPathParams,
  PatchApiV1PecegepayBilletCancelSerialQueryParams,
} from "../../types/pecegePayBilletController/PatchApiV1PecegepayBilletCancelSerial.ts";

export const patchApiV1PecegepayBilletCancelSerialPathParamsSchema = z.object({
  serial: z.coerce.number().int(),
}) as unknown as ToZod<PatchApiV1PecegepayBilletCancelSerialPathParams>;

export const patchApiV1PecegepayBilletCancelSerialQueryParamsSchema = z
  .object({
    cancelReason: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<PatchApiV1PecegepayBilletCancelSerialQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1PecegepayBilletCancelSerial200Schema =
  z.boolean() as unknown as ToZod<PatchApiV1PecegepayBilletCancelSerial200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1PecegepayBilletCancelSerial401Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayBilletCancelSerial401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1PecegepayBilletCancelSerial500Schema =
  z.any() as unknown as ToZod<PatchApiV1PecegepayBilletCancelSerial500>;

export const patchApiV1PecegepayBilletCancelSerialMutationResponseSchema =
  z.lazy(
    () => patchApiV1PecegepayBilletCancelSerial200Schema,
  ) as unknown as ToZod<PatchApiV1PecegepayBilletCancelSerialMutationResponse>;
